





































































import Vue from "vue";

import permission, { PermissionName } from "@/common/mixins/permission";
import pagination, { PaginationForm } from "@/common/mixins/pagination";
import dialog from "@/common/mixins/dialog";
import { User } from "../models/User";

export default Vue.extend({
  mixins: [pagination, permission, dialog],
  data() {
    const users: User[] = [];
    const deleteId = 0;
    return { users, deleteId };
  },
  computed: {
    hasUserCreatePermission() {
      return (this as any).hasPermission(PermissionName.USER_CREATE);
    }
  },
  async created() {
    (this as any).getPaginationRouteQuery();

    await Promise.all([this.getUsers()]);
  },
  watch: {
    async "$route.query"() {
      await this.getUsers();
    }
  },
  methods: {
    async getUsers() {
      const form: PaginationForm = {
        page: (this as any).currentPage,
        perPage: (this as any).perPage
      };
      try {
        const { data, meta } = await (this as any).$dep.userUseCase.getUsers(
          form
        );

        this.users = data;
        (this as any).setPaginationMeta(meta);
      } catch (error) {
        console.log(error.response);
      }
    },
    async deleteUser(id: number) {
      try {
        await (this as any).$dep.userUseCase.deleteUser(id);
        (this as any).alertSuccess("Success", "ลบ User สำเร็จ");
        this.getUsers();
      } catch (error) {
        console.log(error);
      }
    },
    goToUserCreatePage() {
      this.$router.push({ name: "UserCreatePage" });
    },
    goToUserUpdatePage(id: any) {
      this.$router.push({ name: "UserUpdatePage", params: { id } });
    },
    gotoSetPasswordPage(id: any) {
      this.$router.push({ name: "UserSetPasswordPage", params: { id } });
    },
    async deleteUserDialog(user: User) {
      const isComfirmed = await (this as any).alertConfirm(
        "ลบ User",
        `คุณต้องการลบ User Email ${user.email} ใช่ไหม?`
      );
      if (isComfirmed) {
        this.deleteUser(user.id);
      }
    }
  }
});
